export default __webpack_public_path__ + "static/media/callTo.49635804.svg";